import { useState } from 'react';

/** A one-time link with Copy and (on phones) Share buttons. */
export function CopyLink({ url, label }: { url: string; label: string }) {
  const [copied, setCopied] = useState(false);
  const canShare = typeof navigator.share === 'function';

  async function copy() {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard blocked: the field is selectable as a fallback.
    }
  }

  return (
    <div className="copylink">
      <label className="field">
        <span>{label}</span>
        <input readOnly value={url} onFocus={(e) => e.currentTarget.select()} />
      </label>
      <div className="row">
        <button type="button" className="btn" onClick={copy}>
          {copied ? 'Copied' : 'Copy link'}
        </button>
        {canShare && (
          <button type="button" className="btn" onClick={() => navigator.share({ title: 'Squats', url }).catch(() => {})}>
            Share…
          </button>
        )}
      </div>
      <p className="muted small">Works once. Send it only to the person it’s for.</p>
    </div>
  );
}
